// Cores do selo de situação — as mesmas da lista de resultado dos anúncios.
export const TONS = {
  sucesso: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400",
  info: "bg-sky-500/15 text-sky-600 dark:text-sky-400",
  alerta: "bg-amber-500/15 text-amber-600 dark:text-amber-400",
  erro: "bg-red-500/10 text-red-500",
  neutro: "bg-muted text-muted-foreground",
};

export const Selo = ({ situacao, e2e }) => (
  <span data-e2e={e2e} className={`inline-flex whitespace-nowrap text-[10px] font-bold uppercase tracking-wide px-2 py-0.5 rounded-full ${TONS[situacao?.tom] || TONS.neutro}`}>
    {situacao?.rotulo || "—"}
  </span>
);
